import { Dispatch } from "redux";
import { QualificationDetailSortEnum } from "../../../common/enums/QualificationDetailSortEnum";
import { handleEducatorSort } from "./handleEducatorSort";
import { TertiaryTableColumn } from "@hatch-digital-nl/abs-storybook/legacy";

interface Props {
    sortEducators: {
        sortName: string;
        isSorted: boolean;
    };
    dispatch: Dispatch;
}

export const getEducatorTableColumns = (
    props: Props,
): TertiaryTableColumn[] => {
    const { sortEducators, dispatch } = props;

    return [
        {
            value: "Opleider",
            isSortable: true,
            isSorted:
                sortEducators.sortName ===
                QualificationDetailSortEnum.EDUCATOR_DESC,
            sortOnClick: handleEducatorSort({
                sortEducators: {
                    isSorted:
                        sortEducators.sortName ===
                        QualificationDetailSortEnum.EDUCATOR_DESC,
                    sortName: QualificationDetailSortEnum.EDUCATOR,
                },
                dispatch,
            }),
        },
        {
            value: "Website URL",
            isSortable: true,
            isSorted:
                sortEducators.sortName ===
                QualificationDetailSortEnum.WEBSITE_URL_DESC,
            sortOnClick: handleEducatorSort({
                sortEducators: {
                    isSorted:
                        sortEducators.sortName ===
                        QualificationDetailSortEnum.WEBSITE_URL_DESC,
                    sortName: QualificationDetailSortEnum.WEBSITE_URL,
                },
                dispatch,
            }),
        },
    ];
};
